import { getOptionalTrackers } from '../../utils/getOptionalTrackers'

/**
 * Delete local storage items
 */
export function cleanLocalStorage() {
  const localStorageItemsToDelete = getOptionalTrackers(window.localStorage)

  localStorageItemsToDelete.forEach((localStorageItemName) => {
    window.localStorage.removeItem(localStorageItemName)
  })
}
